import Form from './Form';
export default Form;


//////////////////
// WEBPACK FOOTER
// /Users/niko/Work/sketch/antd-pro/ant-design-pro-site/scaffold/node_modules/_antd@3.0.2@antd/es/form/index.js
// module id = 521
// module chunks = 0